module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    class: _vm.pageData ? '' : 'loading'
  }, [_c('div', {
    staticClass: "content container"
  }, [(_vm.currentGallery) ? _c('div', {
    staticClass: "gallery full"
  }, [_c('header', [_c('h1', [_vm._v(_vm._s(_vm.currentGallery.gallery_name))]), _vm._v(" "), (_vm.galleries.length > 1) ? _c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Back to Gallery")]) : _vm._e()]), _vm._v(" "), _c('gallery-full', {
    attrs: {
      "gallery": _vm.currentGallery
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-center",
    style: ({
      marginBottom: '80px'
    })
  }, [(_vm.galleries.length > 1) ? _c('button', {
    staticClass: "btn btn-lg btn-primary",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("Back to Gallery")]) : _vm._e()])], 1) : (_vm.galleries && _vm.galleries.length > 1) ? _c('div', {
    staticClass: "gallery"
  }, [_c('header', [_c('h1', [_vm._v("Gallery")])]), _vm._v(" "), _c('div', {
    staticClass: "gallery-thumb-grid"
  }, _vm._l((_vm.galleries), function(gallery, i) {
    return _c('div', {
      key: i,
      staticClass: "thumb",
      on: {
        "click": function($event) {
          _vm.setCurrentGallery(gallery)
        }
      }
    }, [_c('gallery-thumb', {
      attrs: {
        "gallery": gallery
      }
    })], 1)
  }))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e0a2f6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 393
// module chunks = 2